"use client";

;
import { useContext, useEffect, useRef, useState } from 'react';
import './page.scss';
import BreadCrumb from '@/reusablecomponents/BreadCrumb';
import TypoGraphy from '@/typography';
import MentorDetails from '@/reusablecomponents/MentorDetails';
import Button from '@/uicomponents/Button';
import { projectStrings } from '@/utils/projectstrings';
import useViewType from '@/utils/Hooks/useViewType';
import CardSection from '@/reusablecomponents/CardSection';
import TestimonialsSection from '@/reusablecomponents/TestimonialsSection';
import FaqSection from '@/reusablecomponents/FaqSection';
import NextStep from '@/elements/NextStep';
import QuestionsSection from '@/components/freecourses/QuestionsSection';
import FreeCoursesSection from '@/components/freecourses/FreeCoursesSection';
import { projectImages } from '../../../public/Assets/Images';
import MobileModal from '../../reusablecomponents/Modals/MobileModal';
import AbsoluteModal from '@/reusablecomponents/Modals/AbsoluteModal';
import { RouteStrings } from '../../utils/routestrings';
import { usePathname, useRouter } from 'next/navigation';
import { AppContext } from '../../contexts/appcontext';
import { formatDate } from '../../utils/Functions/formatDate';
import fireConversionApi from '../../utils/facebookTracking';
import eventTracker from '../../utils/eventTracker';
import html2canvas from 'html2canvas';
import ThumbnailImage from '@/utils/Hooks/useThumbnailImage';
const CourseDetail = ({
  testimonials,
  allCourses,
  data,
  NextSchedule,
  industries,
  subIndustriesData,
  relatedCourseData,
  filteredSubIndustries
}: any) => {
  const {
    setCourse,
    showBreadCrumbModal,
    setshowBreadCrumbModal,
    showBreadCrumbDesktopModal,
    setshowBreadCrumbDesktopModal,
    selectedTimeZone
  } = useContext<any>(AppContext);
  const [sliceOutcome, setSliceOutcome] = useState(true);
  const [outcomeShowAll, setoutcomeShowAll] = useState(false);
  const isMobile = useViewType();
  const [shareModal, setshareModal] = useState(false);
  const [fbhover, setfbhover] = useState(false);
  const [linkedinHover, setlinkedinHover] = useState(false);
  const [twitterHover, settwitterHover] = useState(false);
  const [ipData, setIpData] = useState<string>('');
  const [userInfo, setUserInfo] = useState<{
    ip: string;
    userAgent: string;
  }>(typeof window != 'undefined' ? {
    ip: '',
    userAgent: window.navigator.userAgent
  } : {
    ip: '',
    userAgent: ''
  });
  useEffect(() => {
    fetch("https://ipapi.co/json").then(resp => resp.json()).then(data => {
      setIpData(data.ip);
    }).catch(error => console.error(error));
  }, [ipData]);
  useEffect(() => {
    if (ipData) {
      conversionData.ipaddress = ipData;
      conversionData.useragent = window.navigator.userAgent;
      setUserInfo({
        ip: ipData,
        userAgent: window.navigator.userAgent
      });
      fireConversionApi(conversionData, 'PageView');
    }
  }, [ipData]);
  const {
    updateSchemaData,
    settitle,
    setdescription,
    setogImage
  } = useContext<any>(AppContext);
  const pathname = usePathname();
  const router = useRouter();
  const currentURL = typeof window !== 'undefined' ? window.location.href : '';
  const formattedDate = formatDate(NextSchedule?.webinarStartTime, selectedTimeZone);
  const {
    push
  } = useRouter();
  const handleOutcomeReadMore = () => {
    setoutcomeShowAll(true);
    setSliceOutcome(false);
  };
  const currentUrl = `${process.env.NEXT_PUBLIC_APP_URL}${pathname}`;
  const conversionData = {
    ipaddress: userInfo && userInfo.ip,
    useragent: userInfo && userInfo.userAgent,
    url: currentUrl
  };
  const mentorDetails = data?.data.attributes.mentors.data[0].attributes;
  useEffect(() => {
    eventTracker.freeCoursePageDetailsViewed({
      courseName: data?.data?.attributes?.courseName,
      courseId: data?.data?.courseId,
      courseDifficulty: data?.data?.attributes?.courseDifficulty,
      webinarId: data?.data?.attributes?.webinarId,
      webianrSlot: NextSchedule ? NextSchedule?.webinarStartTime : null
    });
  }, [data?.data]);
  const handleButtonClick = (webinarScheduleId: number) => {
    eventTracker.freeCourseCTAClicked({
      courseName: data?.data?.attributes?.courseName,
      courseId: data?.data?.courseId,
      webinarId: data?.data?.attributes?.webinarId,
      mentorName: mentorDetails?.name,
      courseDifficulty: data?.data?.attributes?.courseDifficulty
    });
    if (typeof window !== 'undefined') {
      window.gtag('event', 'click', {
        event_category: 'Button',
        event_label: 'CTA Clicked'
      });
    }
    fireConversionApi(conversionData, 'CTA Clicked');
    window.open(`https://webinar.growthschool.io/webinar/${webinarScheduleId}`);
  };
  useEffect(() => {
    setCourse(data?.data?.attributes?.courseName);
  }, [data?.data?.attributes?.courseName]);
  const setOgImage = async () => {
    const element = document.getElementById('thumbnail');
    if (element) {
      const canvas = await html2canvas(element);
      data = canvas.toDataURL('image/jpg');
      setogImage(data);
    }
  };
  useEffect(() => {
    settitle(data?.data?.attributes?.courseName);
    setdescription(data?.data?.attributes.courseDescription);
    setOgImage();
    if (typeof window !== 'undefined') {
      window?.gtag('config', process.env.NEXT_PUBLIC_GA_ID, {
        event_label: 'Page Viewed',
        page_path: `https://growthschool.io/${pathname}`
      });
    }
    const handleBodyClick = (e: any) => {
      const classNames = ['D_B_1_R_16_160', 'bread_crumb_items_wrapper', 'share_images', 'icon_image'];
      if (classNames.includes(e.target.className)) return;
      setshareModal(false);
      setshowBreadCrumbDesktopModal(false);
    };
    document.body.addEventListener('click', handleBodyClick);
    return () => {
      setshowBreadCrumbDesktopModal(false);
      setshowBreadCrumbModal(false);
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, []);
  const industry = data?.data.attributes.industries.data[0];
  const subIndustry = data?.data?.attributes.subIndustries.data[0];
  const randomNumber = Math.floor(data?.data?.attributes?.courseRating * 75);
  const enrollmentCount = Math.floor(data?.data?.attributes?.courseRating * 5.5);
  const handleMouseEnter = (e: any) => {
    if (showBreadCrumbDesktopModal) {
      setshowBreadCrumbDesktopModal(false);
    }
  };
  const getDifficultyImage = (level: string): string => {
    if (level?.toLowerCase().includes("begin")) return projectImages.chartBeginner;
    if (level?.toLowerCase().includes("inter")) return projectImages.chartIntermediate;
    return projectImages.chartAdvanced;
  };
  const mouseEntered = useRef(false);
  const [showReadMore, setShowReadMore] = useState(data?.data?.attributes.courseDescription?.length > 150);
  const [desc, setdesc] = useState(data?.data?.attributes.courseDescription.substr(0, 150));
  const handleMouseLeave = (e: any) => {
    setTimeout(() => {
      if (!mouseEntered.current) {
        setshareModal(false);
        setfbhover(false);
        setlinkedinHover(false);
        settwitterHover(false);
      }
    }, 500);
  };
  useEffect(() => {
    if (data) document.title = `${data?.data?.attributes?.courseName} | Free Courses by GrowthSchool`;
  }, [data]);
  return <div className='course_details_container_main' data-sentry-component="CourseDetail" data-sentry-source-file="page.tsx">
      <div className="course_detailss_wrapper" onMouseEnter={handleMouseEnter}>
        <div className="course_detail_container">
          <div className="container_content">
            <div className="left_content_wrapper">
              {<div className='bread_crumb_relative'> <BreadCrumb />
                {showBreadCrumbDesktopModal && !isMobile && <AbsoluteModal left={'30px'} top={'25px'} onMouseEnter={() => setshowBreadCrumbDesktopModal(true)} onMouseLeave={() => setshowBreadCrumbDesktopModal(false)}>
                  <div className="bread_crumb_items_wrapper">
                    <TypoGraphy variant={'Desktop/Body 1/R | 16 |160'} text='Free Courses' clickHandler={() => push(RouteStrings.FREECOURSE)} title={projectStrings.upskill()} />
                    <TypoGraphy variant={'Desktop/Body 1/R | 16 |160'} text={industry?.attributes?.industryName} title={`Free ${industry?.attributes?.industryName} Courses`} clickHandler={() => push(RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id))} />
                    <TypoGraphy variant={'Desktop/Body 1/R | 16 |160'} text={subIndustry?.attributes?.subIndustry} title={`Free ${subIndustry?.attributes?.subIndustry} Courses`} clickHandler={() => push(RouteStrings.DYNAMICROUTE(subIndustry?.attributes?.subIndustry.replace(/\s+/g, "-").replace(/-+/g, "-"), 'SUBINDUSTRY', subIndustry?.id))} />
                  </div>
                </AbsoluteModal>}</div>}
              <div className="course_content_wrapper">
                <div className="course_content_title_wrapper">
                  <TypoGraphy variant={isMobile ? 'Mobile/Heading' : 'Desktop/Heading 2'} tagName='h1' text={data?.data?.attributes?.courseName} styles={{
                  maxWidth: "90%"
                }} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  <div className="share_icon_wrapper" onMouseEnter={() => {
                  if (!isMobile) {
                    setshareModal(true);
                  }
                }} onMouseLeave={handleMouseLeave} onClick={() => {
                  if (isMobile) window.navigator.share({
                    url: encodeURIComponent(currentURL)
                  });
                }}>
                    <img src={shareModal ? projectImages.shareHover : projectImages.shareIconFilled} alt="share" />
                    {shareModal && <AbsoluteModal top={"50px"} right={"0"} styles={{
                    boxShadow: '0px 75px 21px 0px rgba(0, 0, 0, 0.00), 0px 48px 19px 0px rgba(0, 0, 0, 0.01), 0px 27px 16px 0px rgba(0, 0, 0, 0.05), 0px 3px 7px 0px rgba(0, 0, 0, 0.10)'
                  }} onMouseEnter={() => mouseEntered.current = true} onMouseLeave={() => mouseEntered.current = false}>
                      <div className="share_images">
                        <img className='icon_image' src={fbhover ? projectImages.fbDark : projectImages.facebook} onMouseEnter={() => setfbhover(true)} onMouseLeave={() => setfbhover(false)} onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`, '_blank')} alt="facebook" />
                        <img className='icon_image' src={linkedinHover ? projectImages.linkedinDark : projectImages.linkedin} onMouseEnter={() => setlinkedinHover(true)} onMouseLeave={() => setlinkedinHover(false)} onClick={() => window.open(`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(currentURL)}`, '_blank')} alt="linkedin" />
                        <img className='icon_image' src={twitterHover ? projectImages.twitterDark : projectImages.twitter} onMouseEnter={() => settwitterHover(true)} onMouseLeave={() => settwitterHover(false)} onClick={() => window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}`, '_blank')} alt="twitter" />
                      </div>
                    </AbsoluteModal>}</div>
                </div>
                {isMobile && <div className="ratings_difficulty">
                  {NextSchedule?.webinarStartTime !== undefined && <div className="rating_wrapper">
                    <img src={projectImages.ratingStar} alt="rating" /> <TypoGraphy text={data?.data?.attributes?.courseRating} variant='Mobile/Body 2/M | 14 | 120' />
                    <TypoGraphy text={`(${randomNumber} ratings)`} variant='Mobile/Body 2/R | 14 | 120' />
                  </div>}
                  <div className="difficulty_wrapper">
                    <img src={projectImages.chart} alt="" />
                    <TypoGraphy text={'Intermediate'} variant='Desktop/Body 2/R | 14 |120' />
                  </div>
                </div>}
                <div className={!isMobile && showReadMore ? "fade_out fade_" : "fade_out"}>
                  {<TypoGraphy text={data?.data?.attributes.courseDescription} variant={isMobile ? 'Mobile/Body 1' : 'Desktop/Body 1/R | 16 |160'} styles={{
                  fontSize: isMobile ? "16px" : "",
                  fontWeight: isMobile ? "400" : "",
                  lineHeight: isMobile ? "135%" : ""
                }} />}
                </div>
                {showReadMore && !isMobile && <div className="absolute_read_more_div" onClick={() => {
                setShowReadMore(false);
                setdesc(data?.data?.attributes.courseDescription);
              }}>
                    <TypoGraphy text='Read More' variant='Mobile/Body 1/M | 16 | 120' /> <img src={projectImages.faqArrowDown} alt="readmore" style={{
                  maxWidth: "10px",
                  maxHeight: "10px"
                }} /></div>}
                {isMobile && <div className="course_card">
                  <div className="image_wrapper">
                    {NextSchedule?.webinarStartTime !== undefined && <div className="date_time_tag_wrapper">
                      <TypoGraphy text={formattedDate} variant='Mobile/Tags' />
                    </div>}

                    <ThumbnailImage itemId={data?.data?.id} />
                    <div className='thumbnail_text'>
                      <TypoGraphy text={NextSchedule?.webinarStartTime !== undefined ? data?.data?.attributes.thumbnailText : "Coming Soon"} variant='Mobile/Heading 1/S | 20 | 120'></TypoGraphy>
                    </div>
                  </div>
                  <div className="mentors_section">
                    <TypoGraphy text='Mentor' variant='Label/Program Tag - Regular' />
                    <MentorDetails mentorImageUrl={mentorDetails?.mentorImageUrl} name={mentorDetails?.name} designation={mentorDetails?.designation} companyName={mentorDetails?.companyName} />
                  </div>
                </div>}
                <div className="certificate_wrapper">
                  <div className="certificate_text_wrapper">
                    <div className="certificate_heading_wrapper">
                      <TypoGraphy text={projectStrings.ask} tagName='h3' variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    </div>
                    <div className="certificate_sub_heading">
                      <TypoGraphy text={projectStrings.certified} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    </div>
                  </div>
                  <div className="certificate_image_wrapper">
                    <img src={projectImages.certificateMentor} alt="certificate" />
                  </div>
                </div>
                <div className="outcomes_wrappeer">
                  <TypoGraphy text={'Learning Objectives'} tagName='h2' variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  <div className="outcomes_list_wrapper">
                    {data?.data?.attributes?.outcomes?.map((outcome: any, index: number) => {
                    if (sliceOutcome && index > 3) return null;
                    if (index <= 3 && index > 2) return <div className='outcome_item' key={`outcome_${index}`}>
                          <TypoGraphy text={`${index + 1}. ${outcome.title}`} tagName='strong' variant={isMobile ? 'Mobile/Body 2/M | 14 | 120' : 'Desktop/Body 1/M | 16 |120'} styles={{
                        opacity: outcomeShowAll ? 1 : 0.3
                      }} />
                          <TypoGraphy text={outcome.description} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 1/R | 16 |160'} styles={{
                        opacity: outcomeShowAll ? 1 : 0.1,
                        lineHeight: isMobile ? "140%" : ""
                      }} />
                        </div>;
                    return <div className='outcome_item' key={`outcome_${index}`}>
                          <TypoGraphy text={`${index + 1}. ${outcome.title}`} variant={isMobile ? 'Mobile/Body 2/M | 14 | 120' : 'Desktop/Body 1/M | 16 |120'} />
                          <TypoGraphy text={outcome.description} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 1/R | 16 |160'} styles={{
                        lineHeight: isMobile ? "140%" : ""
                      }} />
                        </div>;
                  })}
                  </div>
                  {!outcomeShowAll && <div className="outcomes_read_more" onClick={handleOutcomeReadMore}>
                    <TypoGraphy text='Read More' variant='Mobile/Body 1/M | 16 | 120' /> <img src={projectImages.faqArrowDown} alt="readmore" style={{
                    maxWidth: "10px",
                    maxHeight: "10px"
                  }} />
                  </div>}
                </div>
                <div className="who_is_it_for_wrapper">
                  <TypoGraphy tagName='h2' text={isMobile ? "Is this Free Course for me?" : "Who's it for"} variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  <ul className="categories_wrapper">
                    {data?.data?.attributes?.whoIsItFor.map((category: any, index: number) => <li className="category_wrapper" key={`category_${index}`}>
                      <img src={projectImages.greenTick} alt="tick" />
                      <TypoGraphy text={category.title} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 1/R | 16 |120'} />
                    </li>)}
                  </ul>
                </div>
                <div className="testimonial_wrapper">
                  <TestimonialsSection title={projectStrings.learners} type={'TESTIMONIAL'} data={testimonials} data-sentry-element="TestimonialsSection" data-sentry-source-file="page.tsx" />
                </div>
                <div className="course_content_details">
                  <div className="question_wrapper">
                    <TypoGraphy text={'What will I learn'} tagName='h2' variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    <div className="question_fade_out">
                      <TypoGraphy text={data?.courseCurriculumDescription} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |160'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    </div>
                  </div>
                  <div className="chapters_wrapper" style={isMobile ? {
                  paddingTop: data?.courseCurriculumDescription ? "40px" : "0px"
                } : {}}>
                    {data?.data?.attributes.courseCurriculum.map((chapter: any, index: number) => {
                    return <div className="chapter_wrapper" key={`chapter_item_${index}`}>
                          <ChapterItem chapterName={chapter.title} description={chapter.description} chapterNumber={index + 1} />
                        </div>;
                  })}
                  </div>
                  <div className="mentor_section_wrapper">
                    <TypoGraphy tagName='h3' text={'Meet your Mentor'} variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    <MentorDetails mentorImageUrl={mentorDetails?.mentorImageUrl} name={mentorDetails?.name} designation={mentorDetails?.designation} companyName={mentorDetails?.companyName} data-sentry-element="MentorDetails" data-sentry-source-file="page.tsx" />
                    <TypoGraphy text={mentorDetails?.aboutMentor} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |160'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  </div>
                  <div className="faq_course_wrapper" style={isMobile ? {
                  margin: "8px 0px 40px 0px"
                } : {}}>
                    {data?.data?.attributes?.faq?.length > 0 && <FaqSection data={data?.data?.attributes?.faq} />}
                  </div>
                </div>
              </div>
            </div>
            <div className="right_content_wrapper">
              <div className="mentor_detail_card">
                <div className="mentor_pic_wrapper" id="thumbnail" style={{
                position: "relative"
              }}>
                  <ThumbnailImage itemId={data?.data?.id} data-sentry-element="ThumbnailImage" data-sentry-source-file="page.tsx" />
                  <div className='thumbnail_text'>
                    <TypoGraphy text={NextSchedule?.webinarStartTime === undefined ? "Coming Soon" : data?.data?.attributes.thumbnailText} variant={'Mobile/Heading 1/S | 20 | 120'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx"></TypoGraphy>
                  </div>
                </div>
                <div className="course_details_wrapper">
                  {NextSchedule?.webinarStartTime !== undefined && <div className="detail_item">
                    <img src={projectImages.ratingStar} alt="rating" />
                    <TypoGraphy text={data?.data?.attributes.courseRating} variant='Desktop/Body 2/M | 14 |120' />
                    <TypoGraphy text={`(${randomNumber} ratings)`} variant='Desktop/Body 2/R | 14 |120' />
                  </div>}
                  <div className="detail_item">
                    <img src={getDifficultyImage(data?.data?.attributes.courseDifficulty)} alt="difficulty" />
                    <TypoGraphy text={data?.data?.attributes.courseDifficulty} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  </div>
                  {NextSchedule?.webinarStartTime !== undefined && <div className="detail_item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M8.50033 1.41602C4.59741 1.41602 1.41699 4.59643 1.41699 8.49935C1.41699 12.4023 4.59741 15.5827 8.50033 15.5827C12.4032 15.5827 15.5837 12.4023 15.5837 8.49935C15.5837 4.59643 12.4032 1.41602 8.50033 1.41602ZM11.5816 11.0281C11.4824 11.1981 11.3053 11.2902 11.1212 11.2902C11.0291 11.2902 10.937 11.2689 10.852 11.2123L8.65616 9.90185C8.11074 9.57602 7.70699 8.8606 7.70699 8.23018V5.32602C7.70699 5.0356 7.94783 4.79477 8.23824 4.79477C8.52866 4.79477 8.76949 5.0356 8.76949 5.32602V8.23018C8.76949 8.48518 8.98199 8.8606 9.20158 8.9881L11.3974 10.2985C11.6524 10.4473 11.7374 10.7731 11.5816 11.0281Z" fill="#9A9DA6" />
                    </svg>
                    <TypoGraphy text={formattedDate} variant='Desktop/Body 2/R | 14 |120' />
                  </div>}
                  {NextSchedule?.webinarStartTime !== undefined && <div className="detail_item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M6.75 1.5C4.785 1.5 3.1875 3.0975 3.1875 5.0625C3.1875 6.99 4.695 8.55 6.66 8.6175C6.72 8.61 6.78 8.61 6.825 8.6175C6.84 8.6175 6.8475 8.6175 6.8625 8.6175C6.87 8.6175 6.87 8.6175 6.8775 8.6175C8.7975 8.55 10.305 6.99 10.3125 5.0625C10.3125 3.0975 8.715 1.5 6.75 1.5Z" fill="#9A9DA6" />
                      <path d="M10.56 10.6124C8.46747 9.21741 5.05497 9.21741 2.94747 10.6124C1.99497 11.2499 1.46997 12.1124 1.46997 13.0349C1.46997 13.9574 1.99497 14.8124 2.93997 15.4424C3.98997 16.1474 5.36997 16.4999 6.74997 16.4999C8.12997 16.4999 9.50997 16.1474 10.56 15.4424C11.505 14.8049 12.03 13.9499 12.03 13.0199C12.0225 12.0974 11.505 11.2424 10.56 10.6124Z" fill="#9A9DA6" />
                      <path d="M14.9925 5.50556C15.1125 6.96056 14.0775 8.23556 12.645 8.40806C12.6375 8.40806 12.6375 8.40806 12.63 8.40806H12.6075C12.5625 8.40806 12.5175 8.40806 12.48 8.42306C11.7525 8.46056 11.085 8.22806 10.5825 7.80056C11.355 7.11056 11.7975 6.07556 11.7075 4.95056C11.655 4.34306 11.445 3.78806 11.13 3.31556C11.415 3.17306 11.745 3.08306 12.0825 3.05306C13.5525 2.92556 14.865 4.02056 14.9925 5.50556Z" fill="#9A9DA6" />
                      <path d="M16.4927 12.4428C16.4327 13.1703 15.9677 13.8003 15.1877 14.2278C14.4377 14.6403 13.4927 14.8353 12.5552 14.8128C13.0952 14.3253 13.4102 13.7178 13.4702 13.0728C13.5452 12.1428 13.1027 11.2503 12.2177 10.5378C11.7152 10.1403 11.1302 9.8253 10.4927 9.5928C12.1502 9.1128 14.2352 9.4353 15.5177 10.4703C16.2077 11.0253 16.5602 11.7228 16.4927 12.4428Z" fill="#9A9DA6" />
                    </svg>
                    <TypoGraphy text={`${enrollmentCount}k Learners enrolled`} variant='Desktop/Body 2/R | 14 |120' />
                  </div>}
                </div>
                <div className="mentor_wrapper">
                  <TypoGraphy text={'Mentor'} variant='Desktop/Body 2/M | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  <MentorDetails mentorImageUrl={mentorDetails?.mentorImageUrl} name={mentorDetails?.name} companyName={mentorDetails?.companyName} designation={mentorDetails?.designation} data-sentry-element="MentorDetails" data-sentry-source-file="page.tsx" />
                </div>
                <div className="button_wrapper_mentor">
                  <Button clickHandler={() => handleButtonClick(NextSchedule?.webinarScheduleId)} text='Enrol Now' disabled={NextSchedule?.webinarStartTime === undefined} textColor='white' variant='NormalVariant' backgroundColor='black' textVariant='Desktop/Body 1/M | 16 |120' data-sentry-element="Button" data-sentry-source-file="page.tsx" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="card_section_overflow_wrapper" style={{
      width: isMobile ? "100vw" : "1287px",
      marginLeft: isMobile ? "" : "153px"
    }}>
        <CardSection data={{
        cards: relatedCourseData,
        filters: filteredSubIndustries
      }} industryName={industry?.attributes?.industryName} isFilterArray title={'People also found these Free courses interesting'} data-sentry-element="CardSection" data-sentry-source-file="page.tsx" />
      </div>
      <div className="repeating_content" style={{
      maxWidth: isMobile ? "100vw" : "1134px"
    }}>
        <NextStep data-sentry-element="NextStep" data-sentry-source-file="page.tsx" />
        <QuestionsSection data-sentry-element="QuestionsSection" data-sentry-source-file="page.tsx" />
        <FreeCoursesSection data={industries} subIndustriesData={subIndustriesData} data-sentry-element="FreeCoursesSection" data-sentry-source-file="page.tsx" />
      </div>

      {isMobile && NextSchedule?.webinarStartTime !== undefined && <div className="mobile_enrol_now">
        <div className="date_wrapper">
          <TypoGraphy text='Next Date:' variant='Mobile/Caption/R | 12 | 120' />
          <TypoGraphy text={formattedDate} variant='Mobile/Caption' />
        </div>
        <Button text='Enrol Now' variant='NormalVariant' textColor='white' backgroundColor='black' clickHandler={() => handleButtonClick(NextSchedule?.webinarScheduleId)} textVariant='Mobile/Body 2/M | 14 | 160' />
      </div>}

      {showBreadCrumbModal && isMobile && <MobileModal closehandler={() => setshowBreadCrumbModal(false)}>
        <div className="bread_crumb_items_wrapper">
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text='Free Courses' title={projectStrings.upskill()} clickHandler={() => {
          setshowBreadCrumbModal(false);
          push(RouteStrings.FREECOURSE);
        }} />
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={data?.data.attributes.industries.data[0].attributes.industryName} clickHandler={() => {
          setshowBreadCrumbModal(false);
          push(RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id));
        }} title={`Free ${industry?.attributes?.industryName} Courses`} />
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={data?.data.attributes.subIndustries.data[0].attributes.subIndustry} title={`Free ${subIndustry?.attributes?.subIndustry} Courses`} clickHandler={() => {
          setshowBreadCrumbModal(false);
          push(RouteStrings.DYNAMICROUTE(subIndustry?.attributes?.subIndustry.replace(/\s+/g, "-").replace(/-+/g, "-"), 'SUBINDUSTRY', subIndustry?.id));
        }} />
        </div>
      </MobileModal>}
    </div>;
};
const ChapterItem = ({
  chapterName,
  description,
  chapterNumber
}: any) => {
  const [showDetail, setshowDetail] = useState(true);
  const isMobile = useViewType();
  useEffect(() => {
    setshowDetail(false);
  }, []);
  return <div className="chapter_item" data-sentry-component="ChapterItem" data-sentry-source-file="page.tsx">
      <div className="chapter_content_wrapper" onClick={() => setshowDetail(!showDetail)} style={{
      cursor: "pointer"
    }}>
        <div className="text_wrapper">
          <TypoGraphy text={`Chapter ${chapterNumber}`} variant={isMobile ? 'Mobile/Caption/R | 12 | 120 | 6%' : 'Desktop/Caption/14 | 120 | | 120 | 10% Letter Spacing'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
          <TypoGraphy tagName='h3' text={chapterName} variant={isMobile ? 'Mobile/Body 1/M | 16 | 160' : 'Desktop/Heading 1/M | 20 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
        </div>
        <img src={projectImages.faqArrowDown} alt="down" style={{
        transform: showDetail ? "rotate(180deg)" : ""
      }} />
      </div>
      {showDetail && <div className="detail_wrapper">
        <TypoGraphy text={description} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |160'} />
      </div>}
    </div>;
};
export default CourseDetail;